// Part F motion: wrap the explore-all button's anonymous text so CSS can
// nudge it with the icon (translate needs an element).
export const initExploreButton = () => {
    const link = document.querySelector(".other-apps-more-container .other-apps-more");
    if (link === null || link.querySelector(".other-apps-more-text") !== null) {
        return;
    }
    const text = Array.from(link.childNodes).find(node => {
        return node.nodeType === 3 && node.textContent.trim().length > 0;
    });
    if (text === undefined) {
        return;
    }
    const span = document.createElement("span");
    span.className = "other-apps-more-text";
    span.textContent = text.textContent;
    link.replaceChild(span, text);
};
